// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1711443985625
      var cssReload = require("D:/PROJETS/VITISSIA/2024/vitissiapro/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  